<ion-content class="ion-padding">
  Projeto : {{projeto}}<br/>
  Campanha: {{campanha}}<br/>
  Local: {{local}}<br/>
  Grupos: {{grupos}}<br/>
  Método: {{metodo}}<br/>

</ion-content>
